const accommodationAmenitiesClass = '.accommodation-amenities';
const descriptionOpenedClass = 'accommodation-amenities__description--opened';

function init() {
  const blocks = document.querySelectorAll(accommodationAmenitiesClass);

  blocks.forEach((block) => {
    const listItems = block.querySelectorAll('.accommodation-amenities__description li');
    const readMoreButton = block.querySelector('.accommodation-amenities__read-more');
    const readLessButton = block.querySelector('.accommodation-amenities__read-less');

    if (listItems.length < 9) {
      readMoreButton.remove();
    }

    readMoreButton.addEventListener('click', (el) => {
      el.target.parentElement.classList.add(descriptionOpenedClass);
    });

    readLessButton.addEventListener('click', (el) => {
      el.target.parentElement.classList.remove(descriptionOpenedClass);
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  init();
});
